import { render, staticRenderFns } from "./WhatsApp.vue?vue&type=template&id=6f6a1a3a&scoped=true"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"
import style0 from "./WhatsApp.vue?vue&type=style&index=0&id=6f6a1a3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6a1a3a",
  null
  
)

export default component.exports